export interface SalesDespatchProductReportInvoice {
  productKey: string;
  productDescription: string;
  makeUp: string;
  customerProduct: string;
  customerLineRef: string;
  grossQuantity: number;
  nettQuantity: number;
  price: number;
  value: number;
  balanceToFollow: number;
  unitOfMeasure: string;
  priceListUnitOfMeasure: string;
  noOfItems: number;
  currencySymbol: string;
  returnMessage: string;
  countryOfOrigin: string;
  tariffCode: string;
}
